export enum AccessCodeResourceType {
  creditCard = 'CREDIT_CARD',
}
export interface AccessCodeListResponse {
  code: string
  resourceId: string
  resourceType: string
  email: string
  remaining: string
  createdAt: number
  updatedAt: number
}

export class AccessCodeListModel {
  public code: string
  public resourceType: string
  public resourceId: string
  public email: string
  public remaining: string
  public createdAt: number
  public updatedAt: number

  public constructor(data: AccessCodeListResponse) {
    this.code = data.code
    this.resourceId = data.resourceId
    this.resourceType = data.resourceType
    this.email = data.email
    this.remaining = data.remaining
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
  }
}
